import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';
import FinalExpenseAboutMeForm from "../../FinalExpense/steps/AboutMeForm";
import GroupIcon from '../../../../../src/icons/model-group.svg?react';
import ScaleIcon from '../../../../../src/icons/model-scale.svg?react';
import { getPrimaryColor } from "../Helpers/Utility";
import "./BasicInfoSummary.scss"

export default function BasicInfoSummaryFinalExpenseModel(props) {
    const ageSpecs = props.ageSpecs || { min: 50, max: 85 };
    const primaryBrandColor = getPrimaryColor();
    
    return (
        <Modal 
            show={props.openEditPopUp} 
            onHide={props.closeModal} 
            onClose={props.closeModal}
            backdrop="true"
            className="basicInfo-modal icon-bg">
            <Modal.Header className="d-flex justify-content-center" closeButton>
                <Modal.Title className="modal-title">{props.isPurlVerification ? "Confirm Your Information" : "Your Insurance Profile"}</Modal.Title>
                <div className="group-icon"><SvgIcon color='primary' component={GroupIcon} className="icon" viewBox="0 0 80 81" /></div>
            </Modal.Header>
            <Modal.Body className="form-content d-flex justify-content-center">
              <FinalExpenseAboutMeForm
                  ageSpecs={ageSpecs} 
                  hideNextButton={true} 
                  hideCoverage={true} 
                  showQuoteButton={props.openEditPopUp} 
                  setOpenEditPopUp={props.setOpenEditPopUp} 
                  openEditPopUp={props.openEditPopUp}
                  isPurlVerification={props.isPurlVerification}
                  selectedQuote={props.selectedQuote} 
                  brandTheme={primaryBrandColor} />
           </Modal.Body>
            <div className="Scale-icon"><SvgIcon component={ScaleIcon} color='primary' className="icon" viewBox="0 0 109 85" /></div>
        </Modal>
    )
}

BasicInfoSummaryFinalExpenseModel.propTypes = {
    closeModal: PropTypes.func.isRequired,
}
